// DS: C119B
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import ChatTitleBlock from '../../ChatTitleBlock';
import s from './ChatSummaryItemCompact.scss';
export var ChatSummaryItemCompact = function (_a) {
    var chatroom = _a.chatroom, className = _a.className, avatarClassName = _a.avatarClassName, onClick = _a.onClick, ariaLabel = _a["aria-label"], _b = _a.tag, Tag = _b === void 0 ? 'section' : _b, currentUser = _a.currentUser;
    if (!chatroom) {
        return React.createElement("div", null, "Failed to render chatroom");
    }
    return (React.createElement(Tag, { className: classnames(s['root'], className) },
        React.createElement(PlainButtonOrLink, { className: s['button'], onClick: onClick, "aria-label": ariaLabel, biData: {
                evid: BiEventType.CHAT_SELECT,
                chat_uuid: chatroom.id,
            } }),
        React.createElement(ChatTitleBlock, { chatroom: chatroom, className: className, avatarClassName: avatarClassName, currentUser: currentUser })));
};
ChatSummaryItemCompact.displayName = 'ChatSummaryItemCompact';
export default ChatSummaryItemCompact;
//# sourceMappingURL=ChatSummaryItemCompact.js.map